// extracted by mini-css-extract-plugin
export default {"item_details":"ItemDetails_item_details__a5D5n","item_info":"ItemDetails_item_info__RlWyR","rating-container":"ItemDetails_rating-container__klmrs"};